import { Component, EventEmitter, Output } from '@angular/core'

@Component({
  selector: 'app-layer-config',
  templateUrl: './layer-config-base.component.html',
  standalone: false,
})
export class LayerConfigComponent {
  @Output() closed = new EventEmitter<void>()
}
